var map = {
	"./alert-triangle.svg": "AF7p",
	"./award.svg": "1W9C",
	"./book.svg": "nWDU",
	"./clipboard.svg": "1q+c",
	"./compass.svg": "p/pw",
	"./external-link.svg": "wZUv",
	"./github.svg": "nr3q",
	"./gitlab.svg": "2ir1",
	"./globe.svg": "T39O",
	"./home.svg": "jdp8",
	"./lock.svg": "vuvZ",
	"./mail.svg": "aaIl",
	"./settings.svg": "kbmK",
	"./user.svg": "kV7K",
	"./users.svg": "gh9c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eO/O";


//////////////////
// WEBPACK FOOTER
// ./src/icons ^\.\/.*\.svg$
// module id = eO/O
// module chunks = 0